import React, {Component} from 'react'
import {
  Button,
  Card,
  Form,
  Row,
  Select,
  notification,
  DatePicker,
  Table,
  Modal,
  Popconfirm,
  Col,
} from 'antd'
import {decode} from 'utf8'
import Moment from 'moment'
import {connect} from 'react-redux'

import {
  fetchStoreCoupons,
  redemptionCoupon,
  deleteRedemptionCoupon,
} from 'appRedux/actions/StoreCoupons'
import getDate from 'util/ConfigDates'

const Option = Select.Option
const FormItem = Form.Item

class CuponsForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      dateFrom: getDate('dateFrom'),
      dateTo: getDate('dateTo'),
      visible: false,
      couponState: 0,
      storeId: localStorage.getItem('store_id') || 0,
      validateDateFrom: '',
      helpDateFrom: '',
      validateDateTo: '',
      helpDateTo: '',
    }
  }
  onDetails = recording => {
    return (
      <Button
        onClick={() => {
          Modal.info({
            title: <h2>Detalles</h2>,
            content: (
              <div>
                <br />
                <p>
                  <b>Cupón:</b> {recording.couponCode}
                </p>
                <p>
                  <b>Descripción:</b> {recording.description}
                </p>
                <p>
                  <b>Comprador:</b> {recording.buyerName}
                </p>
                <p>
                  <b>Fecha de compra:</b> {recording.datePurchase}
                </p>
                <p>
                  <b>Fecha de canje:</b> {recording.redemptionDate}
                </p>
              </div>
            ),
            onOk() {},
          })
        }}
      >
        <i className="icon icon-card" />
      </Button>
    )
  }

  onExchange = recording => {
    if (
      recording.redemptionState == 'Comprado' &&
      recording.redemptionState != 'Canjeado'
    ) {
      return (
        <Popconfirm
          title={'Canjear'}
          onConfirm={() => {
            this.props.redemptionCoupon(recording)
            this.props.fetchStoreCoupons(this.state)
            this.onNotificationChange('success')
          }}
          okText="Canjear"
          cancelText="No"
        >
          <Button>
            <i className="icon icon-check" />
          </Button>
        </Popconfirm>
      )
    }
  }

  onDelete = recording => {
    if (
      recording.redemptionState == 'Comprado' &&
      recording.redemptionState != 'Canjeado' &&
      localStorage.getItem('user_id') == 1
    ) {
      return (
        <Popconfirm
          title={'Borrar'}
          onConfirm={() => {
            this.props.deleteRedemptionCoupon(recording)
            this.props.fetchStoreCoupons(this.state)
            this.onNotificationDelete('success')
          }}
          okText="Eliminar"
          cancelText="No"
        >
          <Button>
            <i className="icon icon-trash" />
          </Button>
        </Popconfirm>
      )
    }
  }

  onClickDateFrom = (date, dateString) => {
    this.setState({
      dateFrom: dateString,
      validateDateFrom: '',
      helpDateFrom: '',
    })
  }

  onClickDateTo = (date, dateString) => {
    this.setState({dateTo: dateString, validateDateTo: '', helpDateTo: ''})
  }

  onNotification = (type, value) => {
    if (type == 'success') {
      notification[type]({
        message: 'Éxito',
        description: 'La búsqueda se ha realizado con éxito.',
      })
    } else {
      notification[type]({
        message: 'Error',
        description:
          value ||
          'Debes ingresar fecha desde y hasta para hacer una búsqueda.',
      })
    }
  }

  onNotificationChange = (type, value) => {
    if (type == 'success') {
      notification[type]({
        message: 'Éxito',
        description: 'El cupón se ha canjeado con éxito.',
      })
      this.props.fetchStoreCoupons(this.state)
    } else {
      notification[type]({
        message: 'Error',
        description: value || 'Error al canjear el cupón.',
      })
    }
  }

  onNotificationDelete = (type, value) => {
    if (type == 'success') {
      notification[type]({
        message: 'Éxito',
        description: 'El cupón se ha eliminado con éxito.',
      })
      this.props.fetchStoreCoupons(this.state)
    } else {
      notification[type]({
        message: 'Error',
        description: value || 'Error al eliminar el cupón.',
      })
    }
  }

  onHandleClick = event => {
    event.preventDefault()
    if (this.state.dateFrom !== '' && this.state.dateTo !== '') {
      this.props.fetchStoreCoupons(this.state)
      this.onNotification('success')
      this.props.fetchStoreCoupons(this.state)
    } else {
      this.onNotification('error')
      if (this.state.dateFrom == '') {
        this.setState({
          validateDateFrom: 'error',
          helpDateFrom: 'Fecha desde es un campo obligatorio.',
        })
      } else {
        this.setState({validateStatusBranchOffice: '', helpBrachOffice: ''})
      }
      if (this.state.dateTo == '') {
        this.setState({
          validateDateTo: 'error',
          helpDateTo: 'Fecha hasta es un campo obligatorio.',
        })
      } else {
        this.setState({validateStatusBranchOffice: '', helpBrachOffice: ''})
      }
    }
  }

  validateInputStore = () => {
    if (localStorage.getItem('user_id') == 1) {
      return (
        <Col span={12}>
          <FormItem label="Tienda">
            <Select
              className="gx-mr-3 gx-mb-3"
              defaultValue="Todas"
              onChange={this.handleChangeCombo}
              style={{width: 140}}
            >
              <Option value={0}>Todas</Option>
              {this.arrayC()}
            </Select>
          </FormItem>
        </Col>
      )
    }
  }

  handleBlur = () => {}

  handleFocus = () => {}

  handleChangeSelect = value => {
    this.setState({
      couponState: value,
    })
  }

  arrayC = () => {
    let array = this.props.placeStores
    return array.map((element, index) => {
      return (
        <Option key={index} value={element.id}>
          {decode(element.name)}
        </Option>
      )
    })
  }

  handleChangeCombo = value => {
    this.setState({
      storeId: value,
    })
  }

  render() {
    const columns = [
      {
        title: 'Código de cupón',
        dataIndex: 'couponCode',
        key: 'couponCode',
        render: text => <span>{text}</span>,
      },
      {
        title: 'Descripción',
        dataIndex: 'description',
        key: 'description',
      },
      {
        title: 'Comprador',
        dataIndex: 'buyerName',
        key: 'buyerName',
      },
      {
        title: 'Identificación',
        dataIndex: 'identifier',
        key: 'identifier',
      },
      {
        title: 'Fecha de Compra',
        dataIndex: 'datePurchase',
        key: 'datePurchase',
      },
      {
        title: 'Fecha de canje',
        dataIndex: 'redemptionDate',
        key: 'redemptionDate',
      },
      {
        title: 'Estado',
        dataIndex: 'redemptionState',
        key: 'redemptionState',
      },
      {
        title: 'Acción',
        key: 'action',

        render: (text, record) => (
          <span>
            {this.onDetails(record)}
            {this.onExchange(record)}
            {this.onDelete(record)}
          </span>
        ),
      },
    ]

    const {storeCoupons} = this.props

    let data = storeCoupons.map(coupon => {
      if (coupon.redemptionState == 1) {
        return {
          buyerName: coupon.buyerName,
          couponCode: coupon.couponCode,
          couponId: coupon.couponId,
          datePurchase: coupon.datePurchase,
          description: coupon.description,
          id: coupon.id,
          redemptionDate: coupon.redemptionDate,
          redemptionState: 'Comprado',
          state: coupon.state,
          identifier: coupon.identifier,
        }
      } else {
        return {
          buyerName: coupon.buyerName,
          couponCode: coupon.couponCode,
          couponId: coupon.couponId,
          datePurchase: coupon.datePurchase,
          description: coupon.description,
          id: coupon.id,
          redemptionDate: coupon.redemptionDate,
          redemptionState: 'Canjeado',
          state: coupon.state,
          identifier: coupon.identifier,
        }
      }
    })

    return (
      <Card title="Listar cupones">
        <Card>
          <Form onSubmit={this.onHandleClick}>
            <Row>
              <Col span={12}>
                <FormItem
                  label="Desde :"
                  validateStatus={this.state.validateDateFrom}
                  help={this.state.helpDateFrom}
                  labelCol={{xs: 14, sm: 9, lg: 9, md: 9}}
                >
                  <DatePicker
                    defaultValue={Moment(this.state.dateFrom, 'YYYY-MM-DD')}
                    className="gx-mb-3 gx-w-100"
                    onChange={this.onClickDateFrom}
                  />
                </FormItem>
              </Col>
              <Col span={12}>
                <FormItem
                  label="Hasta : "
                  validateStatus={this.state.validateDateTo}
                  help={this.state.helpDateTo}
                >
                  <DatePicker
                    defaultValue={Moment(this.state.dateTo, 'YYYY-MM-DD')}
                    className="gx-mb-3 gx-w-100"
                    onChange={this.onClickDateTo}
                  />
                </FormItem>
              </Col>
              <Col span={12}>
                <FormItem
                  label="Estado :"
                  labelCol={{xs: 24, sm: 9, lg: 9, md: 9}}
                >
                  <Select
                    showSearch
                    defaultValue="Todos"
                    optionFilterProp="children"
                    onChange={this.handleChangeSelect}
                    filterOption={(input, option) =>
                      option.props.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    style={{width: 140}}
                  >
                    <Option value={0}>Todos</Option>
                    <Option value={1}>Comprados</Option>
                    <Option value={2}>Canjeados</Option>
                  </Select>
                </FormItem>
              </Col>

              {this.validateInputStore()}
            </Row>
            <Row>
              <Col span={20} className="gx-text-right">
                <Button type="primary" onClick={this.onHandleClick}>
                  <i className="icon icon-search" />
                </Button>
              </Col>
            </Row>
          </Form>
        </Card>
        <br />
        <br />
        <Table
          pagination={{pageSize: 5}}
          className="gx-table-responsive"
          columns={columns}
          dataSource={data}
        />
      </Card>
    )
  }
}

function mapStateToProps({placeStores, storeCoupons}) {
  return {
    placeStores,
    storeCoupons,
  }
}

export default connect(
  mapStateToProps,
  {fetchStoreCoupons, redemptionCoupon, deleteRedemptionCoupon},
)(CuponsForm)



// WEBPACK FOOTER //
// ./src/routes/main/Cupons/list/UseForm.js